










































































import { MLink } from "@ulaval/modul-components";
import { Component, Vue } from "vue-property-decorator";
import Minuteur from "../components/Minuteur.vue";
import { Casier } from "../models/Casier";
import store, { actions, modules } from "../store";

@Component({ components: { MLink, Minuteur } })
export default class EnteteULaval extends Vue {
  public async deconnecter(): Promise<void> {
    // On efface le state complet de l'application avant de déconnecter l'utilisateur.
    await store.dispatch(actions.effacerState.name);

    // Retrait du verrou si nécessaire
    if (this.casierUtilisateur !== null) {
      await store.dispatch(modules.cds.actions.retirerVerrouUtilisateur.name, {
        vm: this,
        idCasier: this.casierUtilisateur.id,
      });
    }

    this.$msal.logout();
  }

  get estAuthentifie(): boolean {
    return this.$msal.data.isAuthenticated;
  }

  get nomUtilisateur(): string | null {
    if (this.$msal.data.isAuthenticated && this.$msal.data.user) {
      return this.$msal.data.user.name;
    } else {
      return null;
    }
  }

  private get casierUtilisateur(): Casier | null {
    return store.state.utilisateur.casier;
  }
}
